export default "/images/vendor/flag-icon-css/flags/1x1/dk.svg?c2e570fa503242ab4c3edca6b2acb2cb";